// @mui material components
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";


// This version completely bypasses theme usage and hardcodes everything
// Disable the ESLint warning for the styled component
// eslint-disable-next-line react/prop-types
export default styled(InputBase)(({ ownerState = {} }) => {
  
  // Helper function instead of using theme
  const pxToRem = (px) => `${px / 16}rem`;
  
  // Extract state variables with fallbacks
  const size = ownerState.size || "";
  const error = ownerState.error || false;
  const success = ownerState.success || false;
  const iconDirection = ownerState.iconDirection || "";
  const disabled = ownerState.disabled || false;
  const darkMode = ownerState.darkMode || false;
  
  // Hardcoded color values instead of using theme
  const colors = {
    borderColor: "#d2d6da",
    errorColor: "#f5365c",
    successColor: "#2dce89",
    grey200: "#e9ecef",
    white: "#ffffff",
    transparent: "transparent",
    infoMain: "#49a3f1",
    textMain: "#67748e",
    darkMain: "#344767"
  };
  
  // Base styles
  const baseStyles = {
    backgroundColor: disabled ? `${colors.grey200} !important` : colors.white,
    borderColor: colors.borderColor,
    pointerEvents: disabled ? "none" : "auto",
  };
  
  // Size variations
  const sizeStyles = size === "small" 
    ? {
        fontSize: "0.75rem",
        padding: `${pxToRem(4)} ${pxToRem(12)}`,
      }
    : size === "large"
    ? {
        padding: pxToRem(12),
      }
    : {};
  
  // Error styles
  const errorStyle = error
    ? {
        backgroundImage:
          'url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' fill=\'none\' stroke=\'%23fd5c70\' viewBox=\'0 0 12 12\'%3E%3Ccircle cx=\'6\' cy=\'6\' r=\'4.5\'/%3E%3Cpath stroke-linejoin=\'round\' d=\'M5.8 3.6h.4L6 6.5z\'/%3E%3Ccircle cx=\'6\' cy=\'8.2\' r=\'.6\' fill=\'%23fd5c70\' stroke=\'none\'/%3E%3C/svg%3E")',
        backgroundRepeat: "no-repeat",
        backgroundPosition: `right ${pxToRem(12)} center`,
        backgroundSize: `${pxToRem(16)} ${pxToRem(16)}`,
        borderColor: colors.errorColor,
      }
    : {};
  
  // Success styles
  const successStyle = success
    ? {
        backgroundImage:
          'url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 10 8\'%3E%3Cpath fill=\'%2366d432\' d=\'M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z\'/%3E%3C/svg%3E")',
        backgroundRepeat: "no-repeat",
        backgroundPosition: `right ${pxToRem(12)} center`,
        backgroundSize: `${pxToRem(16)} ${pxToRem(16)}`,
        borderColor: colors.successColor,
      }
    : {};
  
  // Icon direction styles
  const iconDirectionStyle = (iconDirection === "left" || iconDirection === "right")
    ? {
        borderColor: colors.transparent,
        borderRadius: "0.5rem",
      }
    : {};
  
  // Focus styles - using hardcoded values to avoid theme dependency
  let focusedBorderColor = colors.infoMain;
  let boxShadowValue = "none";
  
  if (error) {
    focusedBorderColor = colors.errorColor;
    boxShadowValue = `0 0 0 2px rgba(245, 54, 92, 0.2)`;
  } else if (success) {
    focusedBorderColor = colors.successColor;
    boxShadowValue = `0 0 0 2px rgba(45, 206, 137, 0.2)`;
  }
  
  // Combine and return all styles
  return {
    ...baseStyles,
    ...sizeStyles,
    ...errorStyle,
    ...successStyle,
    ...iconDirectionStyle,
    
    // Input styles
    input: {
      padding: 0,
      color: darkMode ? colors.white : colors.darkMain,
      
      "::placeholder": {
        color: `${darkMode ? colors.white : colors.textMain} !important`,
      },
    },
    
    // Focus styles
    "&.Mui-focused": {
      outline: 0,
      borderColor: focusedBorderColor,
      boxShadow: boxShadowValue,
    },
    
    // Multiline styles
    "&.MuiInputBase-multiline": {
      padding: `${pxToRem(10)} ${pxToRem(12)}`,
    },
  };
});